<template>
    <div id="mutlinewsletter">
        <template v-if="position == 'page'">
            <div class="input-unit">
                <input type="text" id="multinews_vorname" aria-describedby="multinews_vorname" v-model="multinews_vorname">
                <label for="multinews_vorname">{{ $translate("Ceres::Template.addressFirstName") }}</label>
            </div>
            <div class="input-unit">
                <input type="text" id="multinews_nachname" aria-describedby="multinews_nachname" v-model="multinews_nachname">
                <label for="multinews_nachname">{{ $translate("Ceres::Template.addressLastName") }}</label>
            </div>
            <div class="input-unit">
                <input type="text" id="multinews_email" aria-describedby="multinews_email" v-model="multinews_email">
                <label for="multinews_email">{{ $translate("Ceres::Template.myAccountEmail") }}</label>
            </div>
            <h3>{{ $translate("Woerner::Template.nlInteressen") }}</h3>
            <div class="d-flex flex-wrap p-3 mb-3 bg-grey">
                <div class="w-50" v-for="nl in usernewsletter">
                    <div class="form-group form-check">
                        <input type="checkbox" :id="'newsletter_'+nl.name" v-model="nl.checked" class="form-check-input">
                        <label :for="'newsletter_'+nl.name" class="form-check-label" v-html="nl.name"></label>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary btn-appearance btn-block" @click="newsletterSubscribe()">{{ $translate("Woerner::Template.nlsave") }}</button>
            <p class="mt-3 text-center">{{ $translate("Woerner::Template.unSubscribe") }}</p>
        </template>
        <template v-else>
            <div class="widget widget-primary">
                <div>
                    <h3>{{ $translate("Woerner::Template.nlHeader") }}</h3>
                    <p><em>{{ $translate("Woerner::Template.nlHeaderSub") }}</em></p>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="d-block d-lg-flex flex-lg-wrap">
                            <div class="form-group form-check w-25 w-100-mobil" v-for="nl in usernewsletter">
                                <input type="checkbox" :id="'newsletter_'+nl.name" v-model="nl.checked" class="form-check-input">
                                <label :for="'newsletter_'+nl.name" class="form-check-label" v-html="nl.name"></label>
                            </div>
                        </div>
                        <div class="text-right mt-2">
                            <button class="btn btn-primary btn-appearance" @click="newsletterSubscribe()">{{ $translate("Ceres::Template.myAccountSave") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import TranslationService from "../../services/TranslationService";
    export default
    {
        props:
        {
            template:
            {
                type: String,
                default: "#vue-multinewsletter"
            },
            position:
            {
                type: String,
                default: 'page'
            },
            user:
                {
                    default:''
                }

        },
        data: function()
        {
            return {
                newsletterfolders:[],
                ownfolders:[],
                multinews_email:'',
                multinews_vorname:'',
                multinews_nachname:''
            };
        },
        mounted: function()
        {
            let _self = this;
            _self.getNLData();
        },
        created: function()
        {
            vueEventHub.$on("multinewsletter-email", email =>
            {
                this.multinews_email = email
            });
        },
        beforeDestroy()
        {
            vueEventHub.$off('multinewsletter-email')
        },
        methods:
        {
            getNLData: function () {
                let _self = this;
                let user = this.user;
                let userdata = '';
                if(user.hasOwnProperty('email'))
                {
                    userdata = {"email": user.email};
                }
                else
                {
                    if (user)
                    {
                        userdata = {"email": user};
                    }
                    else
                    {
                        userdata = {};
                    }
                }
                $.ajax(
                    {
                        type: 'POST',
                        url: '/nlfolders/'+ App.language + '/',
                        data: userdata,
                        dataType: 'json',
                        success: function (data) {

                            //console.log('response data');
                            //console.log(data);
                            let foldersForMandant = [];
                            for (let i = 0; i < data.folders.length; i++)
                            {
                                if (data.folders[i].clients.length > 0)
                                {
                                    foldersForMandant.push(data.folders[i]);
                                }
                            }
                            //console.log('_self.newsletterfolders');
                           // console.log(_self.newsletterfolders);


                            _self.newsletterfolders = foldersForMandant;

                            //_self.newsletterfolders = data.folders;

                            if (user) {
                                _self.ownfolders = data.customerFolders;
                                _self.proofNL(data.customerFolders)
                            }
                            //console.log('nach if user ');
                            //console.log(_self.newsletterfolders);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            // console.error(errorThrown);
                        }
                    });
            },
            proofNL: function (currentFolders)
            {
                let _self = this;
                for(let i = 0; i<_self.newsletterfolders.length;i++)
                {
                    for(let z = 0; z<currentFolders.length;z++)
                    {
                        if(parseInt(currentFolders[z].folderId) == parseInt(_self.newsletterfolders[i].id) )
                        {
                            _self.newsletterfolders[i].subscribed = true;
                            _self.newsletterfolders[i].checked = true;
                        }
                    }
                }
            },
            newsletterSubscribe: function ()
            {

                let _self       = this;
                let email       = this.multinews_email;
                let vorname     = this.multinews_vorname;
                let nachname    = this.multinews_nachname;
                let newlist     = '';
                let dellist     = '';

                if(!email)
                {
                    email = _self.user.email;
                }
                if(!vorname)
                {
                    vorname = _self.user.firstName;
                }
                if(!nachname)
                {
                    nachname = _self.user.lastName;
                }

                for(let i = 0; i<_self.newsletterfolders.length;i++)
                {
                    if(_self.newsletterfolders[i].hasOwnProperty('subscribed') && _self.newsletterfolders[i].checked===true)
                    {
                        // console.log('bekommt bereits '+_self.newsletterfolders[i].name);
                    }
                    else if (!_self.newsletterfolders[i].hasOwnProperty('subscribed') && _self.newsletterfolders[i].checked===true)
                    {

                        let nldata =
                            {
                                "email":email,
                                "firstName":vorname,
                                "lastName":nachname,
                                "emailFolder":_self.newsletterfolders[i].id
                            }
                        $.ajax(
                            {
                                type:           'POST',
                                url:            '/rest/io/customer/newsletter/',
                                data:           nldata,
                                dataType:       'json',
                                success:        function(data)
                                {
                                    //newlist = newlist+' '+ _self.newsletterfolders[i].name;
                                    CeresNotification.success(TranslationService.translate("Woerner::Template.nlnew",{ name: _self.newsletterfolders[i].name })).closeAfter(3000);
                                    $('.newsletter-modal').modal('hide');
                                },
                                error:          function(jqXHR, textStatus, errorThrown)
                                {
                                    // console.error(errorThrown);
                                }
                            });
                        _self.newsletterfolders[i].subscribed = true;

                    }
                    else if(_self.newsletterfolders[i].hasOwnProperty('subscribed') && _self.newsletterfolders[i].checked===false)
                    {
                        // console.log('empfänger entfernen');
                        $.ajax(
                            {
                                type:           'DELETE',
                                url:            '/rest/io/customer/newsletter/'+email,
                                data:           { "emailFolder":_self.newsletterfolders[i].id },
                                dataType:       'json',
                                success:        function(data)
                                {
                                    //dellist = dellist+' '+_self.newsletterfolders[i].name;
                                    CeresNotification.error(TranslationService.translate("Woerner::Template.nldel",{ name: _self.newsletterfolders[i].name })).closeAfter(3000);
                                },
                                error:          function(jqXHR, textStatus, errorThrown)
                                {
                                    // console.error(errorThrown);
                                }
                            });
                        delete _self.newsletterfolders[i]['subscribed'];
                    }
                    else
                    {
                        //console.log('nix tun');
                    }
                }


                //console.log('subscribed')
            }
        },
        computed:
        {
            usernewsletter: function()
            {
                let _self = this;
                return _self.newsletterfolders;
            }
        }
    }
</script>
